import { iconEye, iconEyeOff } from '@tesla/design-system-icons';
import React, { useState } from 'react';
import { IconButton } from '../icon-button/index.js';
import { FormInputText, Icon } from '../index.js';
export const FormInputPassword = ({ ['aria-label']: ariaLabel = 'View or hide password', hide: externalHide, ...rest }) => {
    const [fallbackHide, setFallbackHide] = useState(true);
    const hide = externalHide !== null && externalHide !== void 0 ? externalHide : fallbackHide;
    return (React.createElement(FormInputText, { trailing: React.createElement(IconButton, { onClick: () => setFallbackHide(!hide), "aria-label": ariaLabel },
            React.createElement(Icon, { data: hide ? iconEye : iconEyeOff, inline: true })), type: hide ? 'password' : 'text', ...rest }));
};
